<template>
  <div>
    <FormRow class="designation" inline>
      <FormSelect field="custom.designation">
        <option selected="selected" value="General Donation">General Donation</option>
        <option value="Baltimore">Baltimore</option>
        <option value="Greater Washington">Greater Washington</option>
        <option value="NOVA">Northern Virginia</option>
        <option value="Philadelphia">Philadelphia</option>
        <option value="Richmond">Richmond</option>
        <option value="Cherry Hill">Cherry Hill</option>
        <!-- <option value="Regional">Regional</option> -->
      </FormSelect>

  
      <ErrorLabel field="custom.designation" style="text-align: right" />
    </FormRow>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { form, getValue, settings, setValue } = usePaymentForm();

    return {
      getValue,
      form,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
.hidden {
  display: none !important;
}
</style>
